module.exports = __webpack_public_path__ + "assets/ATrByCentroidDetailed.cb4ab5222bce972ccfe62da3948d4c23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/ATrByCentroidDetailed.png
// module id = 455
// module chunks = 0